import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string { return twMerge(clsx(inputs)); }

export function formatDate(value: unknown, locale = "en"): string {
  if (typeof value !== "string" || Number.isNaN(Date.parse(value))) return "—";
  return new Intl.DateTimeFormat(locale === "ar" ? "ar-MA" : "en-US", { dateStyle: "medium", timeStyle: "short" }).format(new Date(value));
}

export function formatMoney(value: number, currency = "USD", locale = "en"): string {
  return new Intl.NumberFormat(locale === "ar" ? "ar-MA" : "en-US", { style: "currency", currency }).format(value);
}

export function sanitizeCsvCell(value: unknown): string {
  const text = String(value ?? "");
  const safe = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text;
  return `"${safe.replace(/"/g, '""')}"`;
}

export function downloadCsv(filename: string, rows: Record<string, unknown>[]): void {
  if (!rows.length) return;
  const columns = Array.from(new Set(rows.flatMap(Object.keys)));
  const csv = [columns.map(sanitizeCsvCell).join(","), ...rows.map((row) => columns.map((column) => sanitizeCsvCell(row[column])).join(","))].join("\r\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
